import axiosPost from "./axiosPost";

export const MerchantBOContactoUpd= async (credentials, data, location) => {
    const body = {
        service: "MerchantBOContactoUpd",
        params: {
            merchantId: data.merchantId,
            merchantMail: data.merchantMail,
            merchantCelular: data.merchantCelular,
            merchantInstagram: data.merchantInstagram,
            merchantTelefono: data.merchantTelefono,
            merchantWebSite: data.merchantWebSite,
            merchantFacebook: data.merchantFacebook,
            estadoRegistroCod: data.estadoRegistroCod,
            registroLatitud: location.latitud,
            registroLongitud: location.longitud,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}